// V2 · Bookmark palette. Warmer than V1, softer accents, larger radius.
export const theme = {
  bg:           '#0e1320',
  surface:      '#161d2e',
  surfaceHover: '#1c2540',
  line:         '#222c44',
  line2:        '#2c3650',
  text:         '#e8ecf5',
  dim:          '#8b96b3',
  veryDim:      '#5a6582',
  accent:       '#7cb8ff',
  // semantic colors used by the admin guest-link panel
  ok:  '#7ee8a4',
  err: '#ff8a7a',
} as const;

export const FONT =
  '"Inter", -apple-system, BlinkMacSystemFont, system-ui, sans-serif';

// Used only where we need to show a URL or a token that benefits from
// fixed-width rendering (the guest-link admin panel).
export const FONT_MONO =
  '"JetBrains Mono", ui-monospace, SFMono-Regular, Menlo, monospace';

// Cosmetic accent for each app card. Falls back to the default accent.
const ACCENT_MAP: Record<string, string> = {
  amber:  '#e9a955',
  cyan:   '#7cb8ff',
  violet: '#b29bff',
  orange: '#ff9b66',
  lime:   '#a8d96e',
  pink:   '#f4a8c8',
  red:    '#f08274',
};

export function accentColor(name: string | undefined | null): string {
  if (!name) return theme.accent;
  return ACCENT_MAP[name] ?? theme.accent;
}
